export var config = {
  serverUrl : "https://sumigration.studentscenter.in",
  verificationurl:"https://suverify.studentscenter.in/api",
  migrationurl:"https://sumigration.studentscenter.in/api",
  pdcurl:"https://supdc.studentscenter.in/api",
  convactionurl:"https://suconvocation.studentscenter.in/api",
  socketioUrl : "wss://sumigration.studentscenter.in",
  ENV_sendgrid_Twilio : "production",
  transUploadUrl:"https://sumigration.studentscenter.in/api/attestation/upload_transcript",
  markListUploadUrl : "https://sumigration.studentscenter.in/api/attestationapi/uploadUserMarkList",
  curriculumUploadUrl: "https://sumigration.studentscenter.in/api/attestation/upload_curriculum",
  letterUploadUrl: "https://sumigration.studentscenter.in/api/attestation/upload_gradeToPercentLetter",
  CompetencyletterUploadUrl :"https://sumigration.studentscenter.in/api/attestationupload_CompetencyLetter",
  PaymentIssueUrl :"https://sumigration.studentscenter.in/api/attestation/Upload_PaymentIssueUrl",
  NameChangeLetterUrl :"https://sumigration.studentscenter.in/api/attestation/upload_letterforNameChange",
  WesLetterUrl :"https://sumigration.studentscenter.in/api/WesLetterUrl",
  emailIdOperational :'su.sfc@studentscenter.in',
  numberOperational :'9702301302',
  imageUrl : "https://sumigration.studentscenter.in",
  docUploadUrl :  "https://sumigration.studentscenter.in/api/etranscript/upload_doc",
}
